

























































































































import { JournalEntry } from "../../models/JournalEntry";
import JournalEntryCommunicationTypeIcon from "../JournalEntryCommunicationTypeIcon";
import Dropdown from "../../core/UI/Dropdown.vue";
import InterventionsCount from "./InterventionsCount.vue";
import CommentsCount from "./CommentsCount.vue";
import AttachmentsDropdown from "./AttachmentsDropdown.vue";
import EntryValidationCheckbox from "../entry_detail/EntryValidationCheckbox.vue";
import EObject = JournalEntry.EObject;
import ObjectName = JournalEntry.ObjectName;
import { Contact } from "../../models/Contact";

export default {
    name: "JournalEntryLine",
    components: {
        EntryValidationCheckbox,
        AttachmentsDropdown,
        CommentsCount,
        InterventionsCount,
        Dropdown,
        JournalEntryCommunicationTypeIcon,
    },
    props: {
        entry: JournalEntry,
        showAddCommentButton: Boolean,
    },
    data() {
        return {
            EStatus: JournalEntry.EStatus,
        };
    },
    computed: {
        categoryName(): string {
            return JournalEntry.CategoryName[this.entry.category] || "";
        },
        canDelete(): boolean {
            return (
                this.$hasWebAccess &&
                !this.entry.parent_id &&
                this.entry.category !== JournalEntry.ECategory.Relance
            );
        },
    },
    methods: {
        selectEntry(): void {
            this.$emit("select-entry", this.entry);
        },
        isAbsence(): boolean {
            return (
                this.entry.object &&
                this.entry.object.name === ObjectName[EObject.absence]
            );
        },
        isCoproprieteSensible(): boolean {
            return (
                this.entry.client &&
                this.entry.client.hasTag(Contact.ETag.CoproprieteSensible)
            );
        },
        seeMore(): boolean {
            return this.entry.short_desc != this.entry.description;
        },
        showEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_entry,
                this.entry
            );
        },
        editEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.edit_entry,
                this.entry
            );
        },
        deleteEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.delete_entry,
                this.entry
            );
        },
        addComment(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.create_entry,
                this.entry
            );
        },
        addAbsence(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.create_absence,
                this.entry
            );
        },
        createIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.create_intervention,
                this.entry
            );
        },
        sendNotification(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_notification,
                this.entry
            );
        },
        sendEmail(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_email,
                this.entry
            );
        },
        requestIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.intervention_request,
                this.entry
            );
        },
    },
};
